import bossSCommon from '@/lib/bossSCommon'

/**
 * 検索一覧プレビューPC/SP共通 mixin
 */
export default {
  mixins: [bossSCommon],
  data () {
    return {
      jobSearchResult: {
        report: {}
      }
    }
  },
  computed: {
    id () {
      return this.isPrePublishedAccess ? Number(this.$route.params.jobId) : Number(this.$route.params.offerId)
    }
  },
  created () {
    this.fetchJobSearchResult()
  },
  methods: {
    fetchJobSearchResult () {
      this.$http.secured.get(this.apiPathForJobSearch).then(response => {
        this.$set(this, 'jobSearchResult', response.data)
      })
    }
  }
}
